import React from "react"
import Seo from "../components/Seo"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby-plugin-react-i18next"
import PortableText from "../components/PortableText"

const BlogPost = ({ data }) => {
  const post = data.sanityPost
  return (
    <Layout>
      <Seo lang="fi" title={post.title} />
      <div className="max-w-screen-xl mx-auto">
        <div className="grid3">
          <div className="col-span-3 sm:col-span-1 order-last sm:order-none">
            <figure>
              <GatsbyImage
                image={
                  post.mainImage.asset.localFile.childImageSharp.gatsbyImageData
                }
                className="rounded"
                alt={post.title || "Minä voin"}
              />
            </figure>
            <div>
              <p>
                Aute nisi eu ea amet qui sit mollit commodo id sint. Ea laboris
                nulla qui ad proident dolor. Eiusmod exercitation culpa anim
              </p>
            </div>
            {data.allSanityPost.edges.map(item => {
              return (
                <ul key={item.node.id}>
                  <li className="m-5 list-outside">
                    <Link
                      to={`/blog/${item.node.slug.current}`}
                      activeClassName="activeLink"
                    >
                      {item.node.title}
                    </Link>
                  </li>
                </ul>
              )
            })}
          </div>
          <div className="col-span-3 sm:col-span-2">
            <h1>{post.title}</h1>
            <hr />
            <div className="flex justify-between">
              <small className="font-semibold">{post.author.name}</small>
              <small className="pl-3">{post.publishedAt}</small>
            </div>

            <hr />
            <PortableText textData={post._rawBody} />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query($pathSlug: String!, $language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    sanityPost(slug: { current: { eq: $pathSlug } }) {
      title
      mainImage {
        asset {
          localFile {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
      publishedAt(formatString: "DD/MM/YYYY")
      _rawBody(resolveReferences: { maxDepth: 10 })
      author {
        image {
          asset {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
        name
      }
    }
    allSanityPost {
      edges {
        node {
          id
          slug {
            current
          }
          title
        }
      }
    }
  }
`
export default BlogPost
